import { GrantApplication } from "@/api/applicationQueries"
import { formatGBP } from "../utils"

interface FinancialDetailsProps {
    application: GrantApplication
}

export function FinancialDetails({ application }: FinancialDetailsProps) {
    return (
        <section className="bg-gray-100 border border-input flex flex-col gap-2 rounded-md p-4">
            <div>
                <h2 className="text-lg font-semibold">Financial Details</h2>
            </div>
            <div className="flex flex-wrap justify-between items-start gap-6">
                <div>
                    <h3 className="font-bold">Estimated Turnover</h3>
                    <p className="text-sm">{application.estTurnover}</p>
                </div>
                <div>
                    <h3 className="font-bold">Received Grant Before</h3>
                    <p className="text-sm">{application.receivedGrantBefore}</p>
                </div>
                <div>
                    <h3 className="font-bold">Requested Grant Amount</h3>
                    <p className="text-sm">
                        {formatGBP(
                            parseFloat(
                                application.requestedAmount?.toString() ?? "0"
                            )
                        )}
                    </p>
                </div>
            </div>
        </section>
    )
}
